/* Quiet chapter navigation and bounded, accessible ambient film. */
(() => {
  const root = document.querySelector('.pj-story');
  if (!root) return;
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const films = [...root.querySelectorAll('[data-pj-film]')];
  const states = new Map();
  films.forEach(film => {
    const button = film.parentElement.querySelector('[data-pj-film-toggle]');
    const label = button?.querySelector('[data-pj-film-label]');
    const state = { inView: false, manualPause: false, systemPause: false };
    states.set(film, state);
    const sync = () => {
      if (label) label.textContent = film.paused ? 'Play film' : 'Pause film';
      button?.setAttribute('aria-pressed', String(!film.paused));
    };
    const load = () => {
      const source = film.querySelector('source[data-src]');
      if (source) {
        source.src = source.dataset.src;
        source.removeAttribute('data-src');
        film.load();
      }
    };
    state.play = () => {
      load();
      state.systemPause = false;
      film.muted = true;
      const promise = film.play();
      if (promise && typeof promise.catch === 'function') promise.catch(sync);
    };
    state.pause = () => {
      if (!film.paused) {
        state.systemPause = true;
        film.pause();
      }
    };
    film.addEventListener('play', () => {
      state.manualPause = false;
      films.forEach(other => { if (other !== film) states.get(other)?.pause(); });
      sync();
    });
    film.addEventListener('pause', () => {
      if (!state.systemPause) state.manualPause = true;
      state.systemPause = false;
      sync();
    });
    film.addEventListener('error', sync);
    button?.addEventListener('click', () => {
      if (film.paused) {
        state.manualPause = false;
        state.play();
      } else {
        state.manualPause = true;
        film.pause();
      }
    });
    sync();
  });
  const pauseFilms = () => states.forEach(state => state.pause());
  document.addEventListener('visibilitychange', () => {
    if (document.hidden) pauseFilms();
  });
  window.addEventListener('pagehide', pauseFilms);
  reduced.addEventListener('change', event => { if (event.matches) pauseFilms(); });
  if ('IntersectionObserver' in window) {
    const filmObserver = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        const state = states.get(entry.target);
        state.inView = entry.isIntersecting && entry.intersectionRatio >= .35;
        if (state.inView && !reduced.matches && !document.hidden && !state.manualPause) state.play();
        else if (!state.inView) state.pause();
      });
    }, { threshold: [0, .35] });
    films.forEach(film => filmObserver.observe(film));
  }
  const chapters = [...root.querySelectorAll('.pj-chapter')];
  const links = [...root.querySelectorAll('[data-pj-chapter]')];
  let scheduled = false;
  const updateChapter = () => {
    const edge = window.innerHeight * .35;
    let active = null;
    chapters.forEach(chapter => { if (chapter.getBoundingClientRect().top <= edge) active = chapter.id; });
    links.forEach(link => {
      if (link.dataset.pjChapter === active) link.setAttribute('aria-current', 'location');
      else link.removeAttribute('aria-current');
    });
    scheduled = false;
  };
  const schedule = () => {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(updateChapter);
  };
  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule, { passive: true });
  window.addEventListener('pageshow', updateChapter);
  updateChapter();
})();
